/**
 * Colores de identidad/marca que NO dependen del tema claro/oscuro.
 *
 * Viven aquí (bajo theme/) y no como hex sueltos en los componentes, para que
 * el color esté centralizado y no vuelva a dispersarse. El chrome de admin y
 * fiscal es deliberadamente oscuro en ambos temas; los acentos son de marca.
 */
export const palette = {
  adminHeaderBg: '#001529',
  adminAccent: '#f56a00',
  fiscalHeaderBg: '#003a4d',
  fiscalAccent: '#13c2c2',
  footerBg: '#000000',

  // Acento morado decorativo (p. ej. "adicionales"/nómina). No es un estado.
  accentPurple: '#722ed1',

  // Gradientes de marca de las pantallas de login (pantalla completa).
  adminLoginGradient: 'linear-gradient(135deg, #1E1E2D 0%, #4B418F 100%)',
  adminLoginBtnGradient: 'linear-gradient(90deg, #1E1E2D 0%, #4B418F 100%)',
  adminLoginBadgeGradient: 'linear-gradient(135deg, #FAAD14 0%, #D48806 100%)',
  userLoginGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
};

export default palette;
